module.exports = __webpack_public_path__ + "img/res1.7add34fe.png";